import { useContext, useState } from 'react';
import { FlexContainer, ModalContext, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import Trans from 'Components/Trans';
import { ShareModal } from 'Components/Modal/components';
import { setBodyOverflow } from 'Styles/utils/utils';
import { REFERRAL_TERMS_AND_CONDITIONS_URL } from 'Constants/helpsUrl';
import * as Styled from './styles';
import Features from './components/Feature';
import { HeaderProps } from './types';

const AMOUNT_REFERRAL_DISCOUNT = 100;

const Header = ({ hasReferral, referralLinks }: HeaderProps): JSX.Element => {
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation(locizeNS.MGM);
  const { showModal } = useContext(ModalContext);
  const handleCopy = (): void => {
    navigator.clipboard.writeText(referralLinks[0].url);
    setCopied(true);
  };

  const openShareModal = (): void => {
    setBodyOverflow();
    showModal({
      comp: <ShareModal isFiling={false} />,
    });
  };

  return (
    <Styled.Header justify="center">
      <Styled.HeaderContent direction="column" jusify="start" gap="dimension_32">
        <FlexContainer direction="column" gap="dimension_08">
          <Text type="headline" size="S_L_M" color="dark">
            {t('Referral.Header.Title')}
          </Text>
          <Text color="cold" type="paragraphs" size="M_L_S">
            <Trans
              i18nKey={t('Referral.Header.Subtitle')}
              values={{
                amount: AMOUNT_REFERRAL_DISCOUNT,
              }}
            />
          </Text>
        </FlexContainer>
        <FlexContainer direction="column" gap="dimension_16">
          <Styled.InputTitle type="paragraphs" size="M_L_S" color="dark">
            {t('Referral.Header.Input.Label')}
          </Styled.InputTitle>
          <FlexContainer align="center" justify="space-between">
            <Styled.ShareInput value={referralLinks[0].url} readOnly />
            <Styled.CopyButton onClick={handleCopy} type="button">
              {copied ? (
                <Text type="paragraphs" size="S_XL_S" color="dark">
                  {t('Referral.Header.Input.Copied')}
                </Text>
              ) : (
                <Text type="paragraphs" size="S_XL_S" color="fresh">
                  {t('Referral.Header.Input.Copy')}
                </Text>
              )}
            </Styled.CopyButton>
            <Styled.ShareButton
              size="m"
              mode="primary"
              label={t('Referral.Header.Input.Button')}
              onClick={openShareModal}
            />
          </FlexContainer>
        </FlexContainer>
        <FlexContainer direction="column" gap="dimension_24">
          {!hasReferral && <Features />}
          <a href={REFERRAL_TERMS_AND_CONDITIONS_URL} target="_blank" rel="noreferrer">
            <Styled.Link type="paragraphs" size="S_L_S" color="dark">
              {t('Referral.Header.Terms')}
            </Styled.Link>
          </a>
        </FlexContainer>
      </Styled.HeaderContent>
    </Styled.Header>
  );
};

export default Header;
